export default "__VITE_ASSET__DITGCxRw__"